import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBolt, FaBox, FaSearch, FaStar, FaBell, FaHistory } from "react-icons/fa";
import { API_CORE } from "../../../../../_CORE/API/ApiCORE";
import { AppModal } from "../../../../../_CORE/APP/Templates/_UI/Modal/_index";
import "./_Styles/Center.css";

const unwrap = (response) => response?.data?.data ?? response?.data ?? response ?? [];
const TYPE_LABELS = {
    project: "Proyecto", company: "Compañía", subproject: "Subproyecto", step: "Paso", "step-group": "Grupo de pasos",
    "trello-card": "Trello", credential: "Credencial", link: "Enlace", guide: "Guía", "guide-page": "Página de guía",
    manual: "Manual", "manual-page": "Página de manual", "library-document": "Biblioteca", "snippet-repository": "Repositorio",
    "snippet-file": "Snippet", "wishlist-item": "Wish List", course: "Curso", contact: "Contacto", "notebook-entry": "Cuaderno", "sticky-note": "Nota rápida",
    inbox: "Inbox", reminder: "Recordatorio", template: "Plantilla", runbook: "Runbook", "global-tag": "Etiqueta",
};

const QUICK = [
    { title: "Hoy", subtitle: "Centro operativo personal", url: "/today", icon: <FaBolt /> },
    { title: "Inbox", subtitle: "Captura rápida", url: "/inbox", icon: <FaBox /> },
    { title: "Recordatorios", subtitle: "Vencimientos y avisos", url: "/reminders", icon: <FaBell /> },
    { title: "Favoritos", subtitle: "Todo lo destacado", url: "/favorites", icon: <FaStar /> },
    { title: "Actividad", subtitle: "Cambios recientes", url: "/activity", icon: <FaHistory /> },
];

export const GlobalNotebookSearch = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handler = (event) => {
            if (!(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== "k") return;
            event.preventDefault();
            setOpen((current) => !current);
        };
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, []);

    useEffect(() => { setOpen(false); setQuery(""); setResults([]); }, [location.pathname]);

    useEffect(() => {
        if (!open) return;
        const q = query.trim();
        if (q.length < 2) { setResults([]); setLoading(false); return; }
        setLoading(true);
        const timer = setTimeout(async () => {
            const response = await API_CORE.SERVICES.GET_RESOURCES("/control/search", { q, limit: 50 });
            const rows = unwrap(response);
            setResults(Array.isArray(rows) ? rows : []);
            setLoading(false);
        }, 180);
        return () => clearTimeout(timer);
    }, [query, open]);

    const go = (url) => { if (!url) return; setOpen(false); navigate(url); };
    const items = query.trim().length < 2 ? QUICK : results;

    return <AppModal isOpen={open} onClose={() => setOpen(false)} title="Buscar en NOTEBOOK" description="Proyectos, credenciales, guías, PDFs, snippets, tareas y más." size="lg" className="LStudio__center_palette">
        <div className="LStudio__center_palette_search"><FaSearch /><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Buscá o escribí #produccion…" /><kbd>Ctrl K</kbd></div>
        <div className="LStudio__center_palette_results">
            {loading && <div className="LStudio__center_muted">Buscando…</div>}
            {!loading && items.map((item, index) => <button key={`${item.type || "quick"}-${item.id || index}`} type="button" className="LStudio__center_palette_item" onClick={() => go(item.url)}>
                <span className="LStudio__center_palette_icon">{item.icon || <FaSearch />}</span>
                <span><strong>{item.title}</strong><small>{item.subtitle || TYPE_LABELS[item.type] || item.type || "Acción"}</small></span>
            </button>)}
            {!loading && query.trim().length >= 2 && !items.length && <div className="LStudio__center_muted">No encontré coincidencias.</div>}
        </div>
    </AppModal>;
};
